module.exports = __webpack_public_path__ + "static/template-team-member-2-22bcba33804cc95e6bb62aea4070d4fc.jpg";